import {forEach, get, uniqueId, startsWith} from 'lodash';

export function createFixedLayerId(): string {
    return uniqueId('__fixed');
}

export default function concatMapboxStyles(inputs: GaiaMapboxStyle[]): GaiaMapboxStyle {

    const output: GaiaMapboxStyle = {
        version: 8,
        sources: {},
        layers: []
    };

    forEach(inputs, (input: GaiaMapboxStyle, index: number) => {
        const layerType = input.metadata as LayerType | undefined;
        const prefix = layerType ? `${layerType.uniqueTilecacheKey}__` : '';

        forEach(input.sources, (source: mapboxgl.AnySourceData, id: string) => {
            output.sources![prefix + id] = source;
        });

        forEach(input.layers, (layer: any) => {
            if (layer.type !== 'background') {
                output.layers!.push({
                    ...layer,
                    id: (startsWith(layer.id, '__fixed') ? '' : prefix) + layer.id,
                    source: prefix + layer.source
                });

            } else {
                const opacity = get(layer, 'paint.background-opacity', 1);
                if (layerType && layerType.basemap && opacity === 1) {
                    output.layers = [];
                    output.glyphs = undefined;
                    output.sprite = undefined;
                }

                // We omit "background-pattern" layers because many Mapbox GL styles have a
                // loading grid pattern that becomes visible if a layer is translucent.
                if (index === 0 || !get(layer, 'paint.background-pattern')) {
                    output.layers!.push({
                        ...layer,
                        id: (startsWith(layer.id, '__fixed') ? '' : prefix) + layer.id,
                    });
                }
            }
        });

        if (input['details-template'] && input['interaction-layers']) {
            output['interaction-layers'] = output['interaction-layers'] || [];
            output['details-template'] = output['details-template'] || {};

            forEach(input['interaction-layers'], id => {
                output['interaction-layers']!.push(prefix + id);
            });

            if (input['details-template']['*']) {
                forEach(input['interaction-layers'], id => {
                    output['details-template']![prefix + id] = input['details-template']!['*'];
                });
            } else if (input['details-template']) {
                forEach(input['details-template'], (template, id) => {
                    output['details-template']![prefix + id] = template;
                });
            }
        }

        // Take the topmost zoom and center
        if (input.zoom) output.zoom = input.zoom;
        if (input.center) output.center = input.center;

        // Take the bottommost glyphs and sprite
        if (input.glyphs && !output.glyphs) output.glyphs = input.glyphs;
        if (input.sprite && !output.sprite) output.sprite = input.sprite;
    });

    return output;
}
